import { Col, Row } from 'antd'

import { TransactionMetric } from '../../../../models/analytics'

import TotalTransactions from './TotalTransactions'
import TotalEnergy from '../../../transactions/components/metric/TotalEnergy'
import TotalRevenue from '../../../transactions/components/metric/TotalRevenue'
import TotalUniqueUsers from '../../../transactions/components/metric/TotalUniqueUsers'

interface TransactionStatsProps {
  metrics?: TransactionMetric
  loading: boolean
}

const StatsComponents = [TotalTransactions, TotalEnergy, TotalRevenue, TotalUniqueUsers]

const StatsGroup = ({ metrics, loading }: TransactionStatsProps) => {
  return (
    <Row gutter={[16, 8]}>
      {StatsComponents.map((Stats, index) => (
        <Col xs={24} sm={24} md={12} lg={6} key={index}>
          <Stats metrics={metrics} loading={loading} />
        </Col>
      ))}
    </Row>
  )
}

export default StatsGroup

